import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { WeeklyOffPolicyService } from '../../../Model/WeeklyOffPolicy/weekly-off-policy.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-week-off-policies',
  standalone: true,
  imports: [CommonModule,RouterOutlet,RouterModule,DataTablesModule,LoaderComponent],
  templateUrl: './week-off-policies.component.html',
  styleUrl: './week-off-policies.component.scss'
})
export class WeekOffPoliciesComponent {
  isDisabled: boolean = false;

  TableDatas = [];
  WeekOffData : any[] = [] ;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private weeklyoffpolicy: WeeklyOffPolicyService,
    protected common: CommonService,
    private tooltip : TooltipService,
    private toast : ToastService,
    private download : DownloadSampleService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.WeeklyOffGroupMappingSelectGet();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  WeeklyOffGroupMappingSelectGet() {
    this.isDisabled = true;
    this.weeklyoffpolicy.WeeklyOffGroupMappingSelectGet({ SelectType: 1, ESS_WeekOffPolicyRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = response.Table;
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table2.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.TableDatas = Object.values(this.TableDatas);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'WeekOffPolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.WeekOffData = data;
        if( this.WeekOffData.length > 0){
          this.download.exportToExcel(this.WeekOffData, "WeekOffPolicies_data");
          this.isDisabled = false
        }
        else{
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}
